import script from "./Summary16167Section.vue?vue&type=script&setup=true&lang=ts"
export * from "./Summary16167Section.vue?vue&type=script&setup=true&lang=ts"

import "./Summary16167Section.vue?vue&type=style&index=0&id=576d3c7b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-576d3c7b"]])

export default __exports__